module.exports = {"title":"Please set group ID for this transction","groups":"Set GroupId from Last 10 Already Settled Groups","newGroupId":"New Group ID","cancel":"Cancel","create":"Create A New Group","add":"Add To Existed Group"}


//////////////////
// WEBPACK FOOTER
// ./src/lang/en/components/grouptour/create/group.json
// module id = HBCD
// module chunks = 58